
























import { Component, Vue, Watch } from "vue-property-decorator";
import { configuration, routeInfo } from "./config/host.config";
import { Hosts, host } from "./config/host-objects";
import { secondServise } from "./services/_shared/time-servise";

import EmptyLayout from "@/components/layouts/EmptyLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import DashboardLayout from "@/components/layouts/DashboardLayout.vue";
import Authorized from "@/components/checkers/Authorized.vue";
import QuickScroll from "@/components/app/quick-scroll.vue";
import Orders from "@/components/checkers/Orders";
import RoomServiceChecker from "@/components/checkers/RoomServiceChecker";
import AdminPassword from "./components/app/admin-password.vue";

@Component({
  components: {
    DashboardLayout,
    EmptyLayout,
    MainLayout,
    Authorized,
    QuickScroll,
    Orders,
    RoomServiceChecker,
    AdminPassword,
  },
})
class App extends Vue {
  inactivityTimer: ReturnType<typeof setTimeout> | undefined;
  dismissSecs = 600;
  dismissCountDown = 0;

  get layout(): string {
    return this.$route.meta
      ? (this.$route.meta.layout || "main") + "-layout"
      : "main-layout";
  }

  countDownChanged(dismissCountDown: number): void {
    this.dismissCountDown = dismissCountDown;
  }

  @Watch("$store.getters.isAdmin")
  resetInactivityTimer(): void {
    const minutes = (n: number) => secondServise(n * 60);
    if (this.$isRoot() || !this.$store.getters.isAdmin) return;
    clearTimeout(this.inactivityTimer);
    this.dismissCountDown = this.dismissSecs;
    this.inactivityTimer = setTimeout(() => {
      this.$store.dispatch("setAdmin", false);
    }, minutes(10));
  }

  async getShipsCode(): Promise<void> {
    try {
      const config = await this.$axios.get(routeInfo.config);
      if (config.status === 200) {
        this.$store.dispatch("changeID", config.data.ship_code);
        this.$cookies.set("hotelCode", config.data.ship_code);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async createConfiguration(): Promise<void> {
    try {
      const config = { params: { "match[app]": "settings" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        if (configRes.data.settings.languages)
          this.$store.dispatch(
            "changeLanguages",
            configRes.data.settings.languages
          );
        if (configRes.data.settings.zit !== undefined)
          this.$store.dispatch("set_zit_status", configRes.data.settings.zit);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async crealeCurrencyList(): Promise<void> {
    const uri = configuration.currency.main;
    const params = { "match[show]": true, "match[deleted][value]": false };
    try {
      const res = await this.$axios.get(uri, { params });
      if (res.status === 200) this.$store.dispatch("setCurensy", res.data);
    } catch (error) {
      console.error(error);
    }
  }

  changeTitle(): void {
    if (!this.$getRootPermition()) return;
    const hosts: { [x: string]: string } = Hosts;
    for (const name of Object.keys(Hosts)) {
      if (host == hosts[name]) {
        document.title = `CMS: ${name}`;
      }
    }
  }

  mounted(): void {
    this.createConfiguration();
    this.getShipsCode();
    this.changeTitle();
    this.crealeCurrencyList();

    window.addEventListener("mousemove", this.resetInactivityTimer);
    window.addEventListener("keydown", this.resetInactivityTimer);
    window.addEventListener("scroll", this.resetInactivityTimer);
    window.addEventListener("click", this.resetInactivityTimer);
  }
}
export default App;
